<box class="error-alert {{data.icon || 'warning'}}">
  <div class="icon {{data.icon || 'warning'}}">
    <img src="./assets/images/sbc/{{data.icon || 'warning'}}.svg" />
  </div>
  <div class="text">
    <div class="error-title">{{ data?.title }}</div>
    <span *ngIf="data?.message || data?.min" class="error-content">
      <span class="error-message">{{ data?.message }}</span>
      <span class="sessionTimer" *ngIf="data.icon=='session-expired' && this.mode!='RM'">
        <span class="sessionTime" id="sessionTimer"></span>
        <span class="min" *ngIf="data.min"> {{data.min}}. </span>
      </span>
      <span class="error-redirect" (click)="redirect()">{{data?.redirect}}</span>
    </span>
  </div>
  <div class="close">
    <fpx-button className="close" btnType="button" (click)="close()"></fpx-button>
  </div>
</box>